module.exports = __webpack_public_path__ + "static/catering-353b2737d3bf3085dfe3881ccfcc03c5.jpg";